import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-thank-you',
  templateUrl: './thank-you.component.html',
  styleUrls: ['./thank-you.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterModule],
})
export class ThankYouComponent implements OnInit, OnDestroy {
  isDestroyed$ = new Subject();
  showActivationMessage = false;

  constructor(private route: ActivatedRoute) {}

  ngOnInit() {
    this.route.queryParams.pipe(takeUntil(this.isDestroyed$)).subscribe((params) => {
      if (params?.invitation === 'true') {
        this.showActivationMessage = false;
        return;
      }
      this.showActivationMessage = true;
    });
  }

  ngOnDestroy() {
    this.isDestroyed$.next(true);
    this.isDestroyed$.complete();
  }
}
